(function() {
  var DialogController,
    bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
    extend = function(child, parent) { for (var key in parent) { if (hasProp.call(parent, key)) child[key] = parent[key]; } function ctor() { this.constructor = child; } ctor.prototype = parent.prototype; child.prototype = new ctor(); child.__super__ = parent.prototype; return child; },
    hasProp = {}.hasOwnProperty;

  DialogController = App.loadClass('core::Angular/DialogController');

  exports.IrrigationDetailsBase = (function(superClass) {
    extend(IrrigationDetailsBase, superClass);

    function IrrigationDetailsBase(scope, transitions, modalInstance) {
      this.scope = scope;
      this.transitions = transitions;
      this.modalInstance = modalInstance;
      this.clearSecondaryInputs = bind(this.clearSecondaryInputs, this);
      this.clearInputs = bind(this.clearInputs, this);
      this.setLoadedEnergySource = bind(this.setLoadedEnergySource, this);
      IrrigationDetailsBase.__super__.constructor.call(this, this.scope, this.transitions, this.modalInstance);
      this.scope.clearInputs = this.clearInputs;
      this.scope.clearSecondaryInputs = this.clearSecondaryInputs;
    }

    IrrigationDetailsBase.prototype.setLoadedEnergySource = function() {
      if (this.scope.details.fuel_type_id) {
        this.scope.details.energy_source = this.scope.energy_sources.find((function(_this) {
          return function(source) {
            return source.id === _this.scope.details.fuel_type_id && (source.default_units != null);
          };
        })(this));
      } else if (this.scope.details.energy_source_id) {
        this.scope.details.energy_source = this.scope.energy_sources.find((function(_this) {
          return function(source) {
            return source.id === _this.scope.details.energy_source_id && (source.default_units == null);
          };
        })(this));
      } else if (this.scope.details.energy_source) {
        this.scope.details.energy_source = this.scope.energy_sources.find((function(_this) {
          return function(source) {
            return source.name === _this.scope.details.energy_source.name;
          };
        })(this));
      }
      if (this.scope.details.secondary_fuel_type_id) {
        return this.scope.details.secondary_energy_source = this.scope.energy_sources.find((function(_this) {
          return function(source) {
            return source.id === _this.scope.details.secondary_fuel_type_id && (source.default_units != null);
          };
        })(this));
      } else if (this.scope.details.secondary_energy_source_id) {
        return this.scope.details.secondary_energy_source = this.scope.energy_sources.find((function(_this) {
          return function(source) {
            return source.id === _this.scope.details.secondary_energy_source_id && (source.default_units == null);
          };
        })(this));
      } else if (this.scope.details.secondary_energy_source) {
        return this.scope.details.secondary_energy_source = this.scope.energy_sources.find((function(_this) {
          return function(source) {
            return source.name === _this.scope.details.secondary_energy_source.name;
          };
        })(this));
      }
    };

    IrrigationDetailsBase.prototype.clearInputs = function() {
      this.scope.details.energy_source = null;
      this.scope.details.pump_pressure = null;
      return this.scope.details.pumping_depth = null;
    };

    IrrigationDetailsBase.prototype.clearSecondaryInputs = function() {
      this.scope.details.secondary_energy_source = null;
      this.scope.details.secondary_pump_pressure = null;
      return this.scope.details.secondary_pumping_depth = null;
    };

    return IrrigationDetailsBase;

  })(DialogController);

}).call(this);
